import {AvailableEntries} from "./AvailableEntries";
import {SelectedEntries} from "./SelectedEntries";
import {SearchInput} from "../SearchInput/SearchInput";
import {ActionButtons} from "./ActionButtons";
import './MultiSelectWide.scss'
import type {Entry, EntryId} from "./types";

type MultiSelectWideProps = {
    parentRoot: HTMLElement
    multiple: boolean,
    availableEntries: Entry[],
    selectedIds: EntryId[],
    maxAllowedSelectedItems?: number, // 0 - unlimited
    forceConvertIdToString?: boolean,
}

type MultiSelectWideCallbacks = {
    onChange: (selectedIds: EntryId[]) => void,
}

export class MultiSelectWide {

    private readonly root: HTMLElement;
    private readonly multiple: boolean;
    private readonly availableEntries: Entry[];
    private readonly selectedIds: EntryId[];
    private readonly callbacks: MultiSelectWideCallbacks;
    private availableEntriesContainer: AvailableEntries;
    private selectedEntriesContainer: SelectedEntries;
    private searchInput: SearchInput;
    private actionButtonsContainer: ActionButtons;
    private enableAddAll: boolean;
    private maxAllowedSelectedItems: number;
    private forceConvertIdToString: boolean;

    constructor(props: MultiSelectWideProps, callbacks: MultiSelectWideCallbacks) {
        this.root = props.parentRoot;
        this.multiple = props.multiple;
        this.availableEntries = props.availableEntries;
        this.selectedIds = props.selectedIds;
        this.forceConvertIdToString = props.forceConvertIdToString || false;
        // console.debug('MultiSelectWide.constructor() this.selectedIds', this.selectedIds);
        // console.debug('MultiSelectWide.constructor() this.selectedIds', this.availableEntries);
        this.callbacks = callbacks;
        this.enableAddAll = props.maxAllowedSelectedItems === undefined || false;
        this.maxAllowedSelectedItems = props.maxAllowedSelectedItems || 0;
        
        if (this.forceConvertIdToString) {
            this.selectedIds = this.selectedIds.map(id => id.toString());
            this.availableEntries = this.availableEntries.map(entry => {
                return {
                    ... entry,
                    id: entry.id.toString(),
                }
            });
        }
        
        this.init();
    }
    
    private init(): void {
        this.root.innerHTML = this.getHTML();

        this.availableEntriesContainer = new AvailableEntries(this.root.querySelector('.available-entries'), {
            onClickEntry: (entry: Entry) => {
                if (this.maxAllowedSelectedItems > 0 && this.selectedEntriesContainer.getCount() >= this.maxAllowedSelectedItems) {
                    // this.actionButtonsContainer.showMaxAllowedSelectedItemsMessage();
                } else {
                    // this.actionButtonsContainer.hideMaxAllowedSelectedItemsMessage();
                    this.selectedEntriesContainer.add(entry);
                    this.availableEntriesContainer.remove(entry);
                    this.availableEntriesContainer.redraw();
                    this.selectedEntriesContainer.redraw();
                    this.actionButtonsContainer.showSelectedCounter(this.selectedEntriesContainer.getCount(), this.maxAllowedSelectedItems);
                    this.callbacks.onChange(this.selectedEntriesContainer.getAll().map(entry => entry.id));
                }
            }
        });

        this.availableEntriesContainer.populate(
            this.availableEntries.filter(entry => this.selectedIds.indexOf(entry.id) === -1)
        );

        this.selectedEntriesContainer = new SelectedEntries(this.root.querySelector('.selected-entries'), {
            onClickEntry: (entry: Entry) => {
                // console.debug('onClickEntry', entry);
                this.availableEntriesContainer.add(entry);
                this.selectedEntriesContainer.remove(entry);
                this.availableEntriesContainer.redraw();
                this.selectedEntriesContainer.redraw();
                this.actionButtonsContainer.showSelectedCounter(this.selectedEntriesContainer.getCount(), this.maxAllowedSelectedItems);
                this.callbacks.onChange(this.selectedEntriesContainer.getAll().map(entry => entry.id));
            }
        });

        this.selectedEntriesContainer.populate(
            this.availableEntries.filter(entry => this.selectedIds.indexOf(entry.id) !== -1)
        );

        this.actionButtonsContainer = new ActionButtons(
            this.root.querySelector('.action-buttons'),
            this.enableAddAll,
            {
            onAddAll: () => {
                this.selectedEntriesContainer.populate([... this.selectedEntriesContainer.getAll(), ... this.availableEntriesContainer.getAll()]);
                this.availableEntriesContainer.clear();
                this.callbacks.onChange(this.selectedEntriesContainer.getAll().map(entry => entry.id));
            }
        });

        this.searchInput = new SearchInput(this.root.querySelector('.search-input'), {
            onChange: (searchString: string) => {
                this.availableEntriesContainer.filter(searchString);
                this.selectedEntriesContainer.filter(searchString);
            }
        });
        
        this.actionButtonsContainer.showSelectedCounter(this.selectedEntriesContainer.getCount(), this.maxAllowedSelectedItems);
        
    }

    private getHTML(): string {
        return `
            <div class="multi-select-wide-container">
                <div class="search-input"></div>
                <div class="action-buttons"></div>
                <div class="available-entries"></div>
                <div class="selected-entries"></div>
            </div>
        `;
    }

}
